module.exports = __webpack_public_path__ + "img/img5.d955952.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img5.png
// module id = 376
// module chunks = 0